(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["kavieli-size-guide-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kavieli-size-guide')) {
    customElements.define('kavieli-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.profile = this.dataset.defaultProfile || 'femme';
        this.material = this.dataset.defaultMaterial || 'standard';
        this.hasUserInput = false;
        this.rows = {
          femme: [
            { size: 'XXS', fr: '32 – 34', chest: 80, hips: 86 }, { size: 'XS', fr: '34 – 36', chest: 84, hips: 90 },
            { size: 'S', fr: '36 – 38', chest: 88, hips: 94 }, { size: 'M', fr: '38 – 40', chest: 92, hips: 98 },
            { size: 'L', fr: '42 – 44', chest: 98, hips: 104 }, { size: 'XL', fr: '44 – 46', chest: 104, hips: 110 },
            { size: '2XL', fr: '48 – 50', chest: 112, hips: 118 }, { size: '3XL', fr: '52 – 54', chest: 120, hips: 126 },
            { size: '4XL', fr: '56 – 58', chest: 128, hips: 134 }, { size: '5XL', fr: '60 – 62', chest: 136, hips: 142 }
          ],
          homme: [
            { size: 'XS', chest: 90 }, { size: 'S', chest: 94 }, { size: 'M', chest: 100 }, { size: 'L', chest: 106 },
            { size: 'XL', chest: 112 }, { size: '2XL', chest: 120 }, { size: '3XL', chest: 128 }, { size: '4XL', chest: 136 }, { size: '5XL', chest: 144 }
          ],
          enfant: [
            { size: '2 ans', height: 92 }, { size: '2 – 3 ans', height: 98 }, { size: '3 – 4 ans', height: 104 },
            { size: '4 – 5 ans', height: 110 }, { size: '5 – 6 ans', height: 116 }, { size: '6 – 7 ans', height: 122 },
            { size: '7 – 8 ans', height: 128 }, { size: '8 – 9 ans', height: 134 }, { size: '9 – 10 ans', height: 140 },
            { size: '11 – 12 ans', height: 152 }
          ]
        };
        this.inputs = Object.fromEntries(['chest', 'hips', 'height'].map((key) => [key, this.querySelector(`[data-ksg-input="${key}"]`)]));
        this.outputs = Object.fromEntries(['chest', 'hips', 'height'].map((key) => [key, this.querySelector(`[data-ksg-output="${key}"]`)]));
        this.fields = Object.fromEntries(['chest', 'hips', 'height'].map((key) => [key, this.querySelector(`[data-ksg-field="${key}"]`)]));
        this.selectionStatus = this.querySelector('[data-ksg-selection]');

        for (const profileButton of this.querySelectorAll('[data-ksg-profile]')) {
          profileButton.addEventListener('click', () => {
            this.hasUserInput = true;
            this.setProfile(profileButton.dataset.ksgProfile);
            if (this.currentRecommendedSize) this.selectProductSize(this.currentRecommendedSize);
          });
        }
        for (const materialButton of this.querySelectorAll('[data-ksg-material]')) {
          materialButton.addEventListener('click', () => {
            this.hasUserInput = true;
            this.setMaterial(materialButton.dataset.ksgMaterial);
            if (this.currentRecommendedSize) this.selectProductSize(this.currentRecommendedSize);
          });
        }
        for (const input of Object.values(this.inputs)) {
          input?.addEventListener('input', () => {
            this.hasUserInput = true;
            this.update();
          });
          input?.addEventListener('change', (event) => {
            event.stopPropagation();
            if (this.currentRecommendedSize) this.selectProductSize(this.currentRecommendedSize);
          });
        }

        this.setProfile(this.profile);
        this.setMaterial(this.material);
      }

      setProfile(profile) {
        this.profile = profile;
        for (const profileButton of this.querySelectorAll('[data-ksg-profile]')) {
          profileButton.setAttribute('aria-pressed', String(profileButton.dataset.ksgProfile === profile));
        }
        this.fields.chest.hidden = profile === 'enfant';
        this.fields.hips.hidden = profile !== 'femme';
        this.fields.height.hidden = profile !== 'enfant';
        this.update();
      }

      setMaterial(material) {
        this.material = material;
        for (const materialButton of this.querySelectorAll('[data-ksg-material]')) {
          materialButton.setAttribute('aria-pressed', String(materialButton.dataset.ksgMaterial === material));
        }
        this.update();
      }

      indexFor(rows, key, value) {
        const found = rows.findIndex((row) => value <= row[key]);
        return found === -1 ? rows.length - 1 : found;
      }

      normalizeLabel(value) {
        return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/^option-/i, '').replace(/[^a-z0-9]/gi, '').toLowerCase();
      }

      surfaceSize(value) {
        return String(value || '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
          .trim()
          .replace(/[–—−]/g, '-')
          .replace(/\s*-\s*/g, '-')
          .replace(/\s+/g, ' ');
      }

      canonicalSizeToken(value) {
        const token = String(value || '').replace(/[^a-z0-9]/gi, '').toUpperCase();
        const aliases = { XXL: '2XL', XXXL: '3XL', XXXXL: '4XL', XXXXXL: '5XL', '2X': '2XL', '3X': '3XL', '4X': '4XL', '5X': '5XL' };
        if (aliases[token]) return aliases[token];
        if (['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'].includes(token)) return token;
        return '';
      }

      sizeKeys(value) {
        const normalized = String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().replace(/([2-5])\s*X\s*L/g, '$1XL');
        const sizes = normalized.split(/[\/,+|\-–—]/).map((part) => this.canonicalSizeToken(part)).filter(Boolean);
        if (sizes.length > 0) return [...new Set(sizes)];
        return [normalized.replace(/[^A-Z0-9]/g, '')].filter(Boolean);
      }

      isAvailable(control) {
        return !control.disabled && control.getAttribute('aria-disabled') !== 'true';
      }

      selectProductSize(size) {
        if (this.dataset.autoSelect === 'false') return;
        const picker = this.closest('product-form')?.querySelector('variant-picker');
        if (!picker) {
          this.setSelectionStatus('La sélection automatique n’est pas disponible sur ce modèle.', 'unavailable');
          return;
        }

        const expectedOptionName = this.normalizeLabel(this.dataset.sizeOptionName || 'Taille');
        const sizeOptionNames = new Set([expectedOptionName, 'taille', 'taile', 'size']);
        const wantedKey = this.sizeKeys(size)[0];
        const wantedSurface = this.surfaceSize(size);
        const radios = [...picker.querySelectorAll('input[type="radio"][data-option-value-id]')].filter((input) => sizeOptionNames.has(this.normalizeLabel(input.name)));
        const selects = [...picker.querySelectorAll('select[name^="option-"]')].filter((select) => sizeOptionNames.has(this.normalizeLabel(select.name)));

        if (radios.length > 0) {
          if (radios.length === 1) {
            const onlySize = radios[0];
            if (this.isAvailable(onlySize)) {
              if (!onlySize.checked) onlySize.click();
              this.setSelectionStatus(`Ce modèle est proposé uniquement en ${onlySize.value}.`, 'selected');
            } else {
              this.setSelectionStatus(`${onlySize.value} est actuellement indisponible sur ce modèle.`, 'unavailable');
            }
            return;
          }
          const candidates = radios.map((control) => ({ control, keys: this.sizeKeys(control.value), surface: this.surfaceSize(control.value) }));
          const exactMatches = candidates.filter((candidate) => candidate.surface === wantedSurface);
          const canonicalMatches = candidates.filter((candidate) => candidate.keys.includes(wantedKey));
          const exactAvailable = exactMatches.filter((candidate) => this.isAvailable(candidate.control));
          const canonicalAvailable = canonicalMatches.filter((candidate) => this.isAvailable(candidate.control));
          const available = exactAvailable.length === 1 ? exactAvailable[0] : (exactMatches.length === 0 && canonicalAvailable.length === 1 ? canonicalAvailable[0] : null);
          if (available) {
            if (!available.control.checked) available.control.click();
            this.setSelectionStatus(`Taille ${available.control.value} sélectionnée automatiquement.`, 'selected');
            return;
          }
          if (exactAvailable.length > 1 || (exactMatches.length === 0 && canonicalAvailable.length > 1)) {
            this.setSelectionStatus(`Plusieurs tailles correspondent à ${size}. Choisissez celle qui convient dans les options du produit.`, 'unavailable');
            return;
          }
          this.reportUnavailable(size, exactMatches.length > 0 || canonicalMatches.length > 0);
          return;
        }

        if (selects.length > 0) {
          const select = selects[0];
          if (select.options.length === 1) {
            const onlySize = select.options[0];
            if (this.isAvailable(onlySize)) {
              this.setSelectionStatus(`Ce modèle est proposé uniquement en ${onlySize.textContent.trim()}.`, 'selected');
            } else {
              this.setSelectionStatus(`${onlySize.textContent.trim()} est actuellement indisponible sur ce modèle.`, 'unavailable');
            }
            return;
          }
          const candidates = [...select.options].map((option) => ({ control: option, keys: this.sizeKeys(option.value || option.textContent), surface: this.surfaceSize(option.value || option.textContent) }));
          const exactMatches = candidates.filter((candidate) => candidate.surface === wantedSurface);
          const canonicalMatches = candidates.filter((candidate) => candidate.keys.includes(wantedKey));
          const exactAvailable = exactMatches.filter((candidate) => this.isAvailable(candidate.control));
          const canonicalAvailable = canonicalMatches.filter((candidate) => this.isAvailable(candidate.control));
          const available = exactAvailable.length === 1 ? exactAvailable[0] : (exactMatches.length === 0 && canonicalAvailable.length === 1 ? canonicalAvailable[0] : null);
          if (available) {
            if (select.value !== available.control.value) {
              select.value = available.control.value;
              select.dispatchEvent(new Event('change', { bubbles: true }));
            }
            this.setSelectionStatus(`Taille ${available.control.textContent.trim()} sélectionnée automatiquement.`, 'selected');
            return;
          }
          if (exactAvailable.length > 1 || (exactMatches.length === 0 && canonicalAvailable.length > 1)) {
            this.setSelectionStatus(`Plusieurs tailles correspondent à ${size}. Choisissez celle qui convient dans les options du produit.`, 'unavailable');
            return;
          }
          this.reportUnavailable(size, exactMatches.length > 0 || canonicalMatches.length > 0);
          return;
        }

        this.setSelectionStatus('La sélection automatique n’est pas disponible sur ce modèle.', 'unavailable');
      }

      reportUnavailable(size, exists) {
        const message = exists
          ? `La taille ${size} correspond à vos mesures, mais elle est actuellement indisponible sur ce modèle.`
          : `La taille ${size} correspond à vos mesures, mais elle n’est pas proposée sur ce modèle.`;
        this.setSelectionStatus(message, 'unavailable');
      }

      setSelectionStatus(message, state) {
        if (!this.selectionStatus) return;
        this.selectionStatus.textContent = message;
        this.selectionStatus.dataset.state = state;
      }

      update() {
        for (const [key, input] of Object.entries(this.inputs)) {
          if (!input) continue;
          const percent = ((Number(input.value) - Number(input.min)) / (Number(input.max) - Number(input.min))) * 100;
          input.style.setProperty('--ksg-progress', `${percent}%`);
          if (this.outputs[key]) this.outputs[key].innerHTML = `${input.value}<span> cm</span>`;
        }

        const rows = this.rows[this.profile];
        let index = 0;
        let note = '';
        if (this.profile === 'enfant') {
          index = this.indexFor(rows, 'height', Number(this.inputs.height.value));
          note = 'Basée sur la taille de l’enfant.';
        } else if (this.profile === 'homme') {
          index = this.indexFor(rows, 'chest', Number(this.inputs.chest.value));
          note = 'Basée sur votre tour de poitrine.';
        } else {
          const chestIndex = this.indexFor(rows, 'chest', Number(this.inputs.chest.value));
          const hipsIndex = this.indexFor(rows, 'hips', Number(this.inputs.hips.value));
          index = Math.max(chestIndex, hipsIndex);
          note = chestIndex === hipsIndex ? 'Vos deux mesures concordent.' : (hipsIndex > chestIndex ? 'Déterminée par votre tour de hanches.' : 'Déterminée par votre tour de poitrine.');
        }
        if (this.profile !== 'enfant' && this.material === 'satin' && index < rows.length - 1) {
          index += 1;
          note = 'Satin peu extensible : nous conseillons la taille au-dessus.';
        }

        const row = rows[index];
        this.currentRecommendedSize = row.size;
        this.querySelector('[data-ksg-size]').textContent = row.size;
        this.querySelector('[data-ksg-equivalent]').textContent = row.fr ? `Équivalent FR ${row.fr}` : (this.profile === 'enfant' ? `Jusqu’à ${row.height} cm` : `Poitrine jusqu’à ${row.chest} cm`);
        this.querySelector('[data-ksg-note]').textContent = note;
        this.querySelector('[data-ksg-prev]').textContent = rows[index - 1]?.size || '';
        this.querySelector('[data-ksg-current]').textContent = row.size;
        this.querySelector('[data-ksg-next]').textContent = rows[index + 1]?.size || '';
        this.querySelector('[data-ksg-robe]').style.transform = `scale(${(0.9 + (index / Math.max(1, rows.length - 1)) * 0.28).toFixed(3)})`;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
